import func from "@uikit/func";
import { sleep } from "@views/thinking-layout-editor/util";
import { getIt } from "@uikit/getIt";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";

const selectApiReg = /^\//;

export const useCotFlowV3 = ({
  getAndSetQueryV3,
  setEdgeValueByWriterV3,
  setCenter,
  corekitRun,
  getSimpleNodeData,
}: {
  getAndSetQueryV3: any;
  setEdgeValueByWriterV3: any;
  setCenter: any;
  corekitRun: any;
  getSimpleNodeData: any;
}): any => {
  const creatorNodesStore = getIt(CreatorNodesStore);
  async function updateNode(id: string, nodeData: any): Promise<any> {
    creatorNodesStore.setNodes((prevList: any) => {
      return prevList.map((l: any) => {
        if (l.id === id) {
          return {
            ...l,
            data: {
              ...l.data,
              lineParam: {
                ...l.data.lineParam,
                ...nodeData,
              },
            },
          };
        }
        return l;
      });
    });
  }

  async function setQuery(group: { node: any; edgeNode: any; edges: any[] }): Promise<void> {
    let nodeData = {};
    const firstEdge = group.edges[0];
    const { node, edgeNode } = group;
    const enterText = firstEdge.data.lineParam.enterText;

    // 普通边并且后台没有返回identifier
    if (selectApiReg.test(enterText) === false && node.data && func.isEmpty(node.data.identifier)) {
      await getAndSetQueryV3(edgeNode.id, enterText, true);
      return;
    }

    if (node.data && !func.isEmpty(node.data.identifier)) {
      // 后台接口返回了identifier
      const { identifier_type: type, identifier_value: value } = node.data.identifier;
      nodeData = {
        lineType: "identifier",
        identifier: { type, value },
      };
    } else {
      // 函数
      nodeData = { lineType: "identifier" };
    }

    await updateNode(edgeNode.id, nodeData);
    creatorNodesStore.setQueryLoadingV3({
      id: edgeNode.id,
      data: {
        isGetQuery: true,
        getQueryLoading: false,
      },
    });
    await setEdgeValueByWriterV3(edgeNode.id, enterText, true);
  }

  async function showFlowByGroupV3(group: { node: any; edgeNode: any; edges: any[] }): Promise<void> {
    const { node, edgeNode } = group;
    setCenter(edgeNode.position.x - 200, edgeNode.position.y, { duration: 300, zoom: 1.2 });
    await setQuery(group);
    await sleep(800);
    setCenter(node.position.x, node.position.y, { duration: 300, zoom: 1.2 });
    await corekitRun({ getSimpleNodeData, edgeId: edgeNode.id });
    await sleep(800);
  }

  return { showFlowByGroupV3 };
};
